/* Apply newsletter signup discount silently (no UI change) */
(function () {
  if (window.SipitSignupDiscount) return;

  function apply(code) {
    code = (code || '').trim();
    if (!code) return Promise.resolve(false);

    try {
      sessionStorage.setItem('sipit_signup_discount', code);
    } catch (e) {}

    return fetch('/discount/' + encodeURIComponent(code), {
      credentials: 'same-origin',
      redirect: 'manual',
    })
      .then(function () {
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  window.SipitSignupDiscount = { apply: apply };
})();
